"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("@ikea-aoa/utilities");
/**
 * This class handles communication with the ROIG application through post message.
 */
var RoigPlatformCommunication = /** @class */ (function () {
    function RoigPlatformCommunication() {
    }
    /**
     * Adds items to shopping bag.
     *
     * @param items List of items.
     * @param vpcCode VPC code.
     */
    RoigPlatformCommunication.prototype.addToCart = function (items, vpcCode) {
        if (utilities_1.IframeUtility.isInsideIframe()) {
            window.parent.postMessage({
                method: 'addToShoppingBag',
                parameters: {
                    items: items.map(function (item) {
                        return { ID: item.id, Type: item.type, Qty: item.quantity };
                    }),
                    vpcCode: vpcCode
                }
            }, '*');
        }
    };
    /**
     * Sets the cart count.
     *
     * @param cartCount Cart count to set.
     */
    RoigPlatformCommunication.prototype.setCartCount = function (cartCount) {
        if (utilities_1.IframeUtility.isInsideIframe()) {
            window.parent.postMessage({
                method: 'setCartCount',
                parameters: {
                    cartCount: cartCount
                }
            }, '*');
        }
    };
    return RoigPlatformCommunication;
}());
exports.default = RoigPlatformCommunication;
//# sourceMappingURL=RoigPlatformCommunication.js.map